export default __webpack_public_path__ + "static/media/GalleryFirstOTSPFullSize.89ac71d3.png";